import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "plan-cards-wrapper w-sm-100" }
const _hoisted_3 = { class: "card-header w-sm-100 sm-mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "Plan Details", -1)
const _hoisted_5 = {
  key: 0,
  class: "line"
}
const _hoisted_6 = {
  key: 1,
  class: "plus iatse-icon-plus"
}
const _hoisted_7 = {
  key: 0,
  class: "plan-general-details card card-toggle"
}
const _hoisted_8 = {
  key: 0,
  class: "plan-general-detail-container card"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-user-shield" })
], -1)
const _hoisted_10 = { class: "plan-general-detail" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", null, " Current Coverage ", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "plan-general-detail-container card" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-calendar-payment-loan" })
], -1)
const _hoisted_15 = { class: "plan-general-detail" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h5", null, " Current Coverage Period ", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "plan-general-detail-container card" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-donate" })
], -1)
const _hoisted_21 = {
  key: 0,
  class: "plan-general-detail"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h5", null, " MRP Balance", -1)
const _hoisted_23 = {
  key: 1,
  class: "plan-general-detail"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h5", null, " MRP Balance ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h4", null, "-", -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "plan-general-detail-container card"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-donate" })
], -1)
const _hoisted_29 = { class: "plan-general-detail" }
const _hoisted_30 = { class: "plan-general-detail-container card" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-money-check-edit" })
], -1)
const _hoisted_32 = { class: "plan-general-detail" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h5", null, " Administrative Fee Met ", -1)
const _hoisted_34 = { class: "plan-general-detail-container card" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-legal" })
], -1)
const _hoisted_36 = { class: "plan-general-detail" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h5", null, " Enrollment Form Sent ", -1)
const _hoisted_38 = {
  key: 0,
  class: "plan-general-details card card-toggle sm-pdt-10"
}
const _hoisted_39 = { class: "plan-general-detail-container card" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-time-quarter" })
], -1)
const _hoisted_41 = { class: "plan-general-detail" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " Lapse "),
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
], -1)
const _hoisted_43 = { class: "plan-general-detail-container card" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-person-circle-xmark" })
], -1)
const _hoisted_45 = { class: "plan-general-detail" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " Participation Termination "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
], -1)
const _hoisted_47 = { class: "plan-general-detail-container card" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-together-people" })
], -1)
const _hoisted_49 = { class: "plan-general-detail" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " Combined Account "),
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
], -1)
const _hoisted_51 = { class: "plan-general-detail-container card" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-person-circle-xmark" })
], -1)
const _hoisted_53 = { class: "plan-general-detail" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " Forfeitures "),
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
], -1)
const _hoisted_55 = { class: "plan-general-detail-container card" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-hr-person" })
], -1)
const _hoisted_57 = { class: "plan-general-detail mr-10" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " QMSCOs "),
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
], -1)
const _hoisted_59 = { class: "plan-upcoming" }
const _hoisted_60 = { class: "container-fluid" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-10" }
const _hoisted_63 = { class: "plan-general-details plan-navigation" }
const _hoisted_64 = { class: "plan-upcoming-navigation" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-down" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = {
  key: 2,
  class: "pending-period"
}
const _hoisted_71 = ["disabled"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-down" }, null, -1)
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "col-md-2" }
const _hoisted_75 = { class: "contribution-table" }
const _hoisted_76 = { class: "capp-account bordered-card width-30" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h4", null, " CAPP Account ", -1)
const _hoisted_78 = {
  key: 0,
  class: "contribution-left-table"
}
const _hoisted_79 = { class: "contribution-left-line" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("h5", null, " Previous Balance: ", -1)
const _hoisted_81 = { class: "contribution-left-lines" }
const _hoisted_82 = { class: "contribution-left-line" }
const _hoisted_83 = { class: "flex" }
const _hoisted_84 = { class: "contribution-left-line" }
const _hoisted_85 = { class: "flex" }
const _hoisted_86 = { class: "contribution-left-line" }
const _hoisted_87 = { class: "flex" }
const _hoisted_88 = { class: "contribution-left-line" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("h5", null, " Total Contributions ", -1)
const _hoisted_90 = { class: "contribution-left-lines" }
const _hoisted_91 = { class: "contribution-left-line" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("h5", null, " Admin Fees: ", -1)
const _hoisted_93 = { class: "contribution-left-line" }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "contribution-left-line" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("h5", null, " Amount Available: ", -1)
const _hoisted_97 = { class: "contribution-left-line" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h5", null, " Co-Payment: ", -1)
const _hoisted_99 = { class: "contribution-left-line" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("h5", null, " Premium Payment: ", -1)
const _hoisted_101 = { class: "contribution-left-line" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("h5", null, " Transfers/Waivers: ", -1)
const _hoisted_103 = { class: "contribution-left-line" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("h5", null, " Ending Balance ", -1)
const _hoisted_105 = { class: "contributions-tables" }
const _hoisted_106 = { class: "contributions-table-wrapper" }
const _hoisted_107 = { class: "contributions-table-item" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("h4", null, " Contribution Detail ", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Receipt Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Wk End"),
    /*#__PURE__*/_createElementVNode("th", null, "Employer/Production"),
    /*#__PURE__*/_createElementVNode("th", null, "Report"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount")
  ])
], -1)
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { key: 1 }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, "No contributions found.")
], -1)
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = { class: "contributions-table-wrapper" }
const _hoisted_115 = { class: "contributions-table-item" }
const _hoisted_116 = { class: "d-flex w-100 align-items-center justify-content-between" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Coverage Begins"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Date Sent"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Due Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance")
  ])
], -1)
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { key: 1 }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, "No statements found.")
], -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = { class: "container-fluid" }
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "col-md-12" }
const _hoisted_125 = ["href"]
const _hoisted_126 = { class: "plan-summary__footer d-flex flex-md-row flex-column w-100" }
const _hoisted_127 = { class: "col-12 col-md-4 d-flex flex-column justify-content-between gap-10" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("h4", null, "Other Coverages", -1)
const _hoisted_129 = { class: "account-actions sm-pdb-10" }
const _hoisted_130 = { class: "col-12 col-md-8" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("h4", null, "Account Actions", -1)
const _hoisted_132 = { class: "action-buttons mt-10 flex-md-row flex-column sm-pdl-0 sm-pdr-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OtherCoverages = _resolveComponent("OtherCoverages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: _normalizeClass(["card-control", { 'plus': !$setup.visibleContent }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleVisible && $setup.toggleVisible(...args)))
        }, [
          ($setup.visibleContent)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          (!$setup.visibleContent)
            ? (_openBlock(), _createElementBlock("i", _hoisted_6))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          ($setup.visibleContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                ($setup.dataLoaded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        ($setup.planSummary.Coverage)
                          ? (_openBlock(), _createElementBlock("h4", _hoisted_12, _toDisplayString($setup.planSummary.Coverage?.Plan ?? 'N/A'), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    ($setup.planSummary.Coverage)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_17, _toDisplayString($setup.planSummary.Coverage.From) + " - " + _toDisplayString($setup.planSummary.Coverage.To), 1))
                      : (_openBlock(), _createElementBlock("h4", _hoisted_18, "N/A"))
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  ($setup.planSummary.Coverage?.MrpBalance > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("h4", null, _toDisplayString($setup.formatCurrency($setup.planSummary.Coverage?.MrpBalance)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                ]),
                ($setup.planSummary.RmrpBalance > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("h5", null, _toDisplayString($setup.isRmrpFrozen ? 'Frozen R-MRP Balance' : 'R-MRP Balance'), 1),
                        _createElementVNode("h4", null, _toDisplayString($setup.formatCurrency($setup.planSummary.RmrpBalance)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PlanCDetails?.AdministrativeFee ? 'Met' : 'Not Met'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PlanCDetails?.EnrollmentForm), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          ($setup.visibleContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PlanCDetails?.Lapse), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.ParticipantTermination ? 'Yes' : 'No'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PlanCDetails?.CombinedAccount ? 'Yes' : 'No'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PlanCDetails?.Forfeitures), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("h4", null, _toDisplayString($setup.planSummary.PlanCDetails?.HasQmsco ? 'Yes' : 'No'), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.navigateToPrevious && $setup.navigateToPrevious(...args)), ["prevent"])),
                  disabled: !$setup.canMovePrev,
                  class: "btn btn-primary btn-navigation btn-prev"
                }, _hoisted_67, 8, _hoisted_65),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formattedPeriods, (period, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(['period', { 'current-period': period.IsCurrent, 'active-period': period.IsActive }])
                  }, [
                    _createTextVNode(_toDisplayString(period.FromFormatted) + " - " + _toDisplayString(period.ToFormatted) + " ", 1),
                    (period.IsCurrent)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_68, "Current"))
                      : (period.IsUpcoming)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_69, _toDisplayString(period.IsUpcoming), 1))
                        : (period.IsPending !== false)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_70, _toDisplayString(period.IsPending), 1))
                          : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.navigateToNext && $setup.navigateToNext(...args)), ["prevent"])),
                  disabled: !$setup.canMoveNext,
                  class: "btn btn-primary btn-navigation btn-next"
                }, _hoisted_73, 8, _hoisted_71)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-tertiary",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.openModal('coverage-history', 'Coverage History', '', null, null, null)), ["prevent"]))
            }, "Coverage History")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_75, [
      _createElementVNode("div", _hoisted_76, [
        _hoisted_77,
        ($setup.dataLoaded && $setup.planSummary.CappAccount && Object.keys($setup.planSummary.CappAccount).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.PREVBAL)), 1)
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(["month", { 'current': $setup.selectedMonth === $setup.planSummary.CappAccount.CONTRIB1?.MonthName }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.selectMonth($setup.planSummary.CappAccount.CONTRIB1?.MonthName)))
                  }, _toDisplayString($setup.formatDateToMonth($setup.planSummary.CappAccount.CONTRIB1?.MonthName)), 3),
                  _createElementVNode("h5", _hoisted_83, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.CONTRIB1.Value)), 1)
                ]),
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(["month", { 'current': $setup.selectedMonth === $setup.planSummary.CappAccount.CONTRIB2?.MonthName }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.selectMonth($setup.planSummary.CappAccount.CONTRIB2?.MonthName)))
                  }, _toDisplayString($setup.formatDateToMonth($setup.planSummary.CappAccount.CONTRIB2?.MonthName)), 3),
                  _createElementVNode("h5", _hoisted_85, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.CONTRIB2.Value)), 1)
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(["month", { 'current': $setup.selectedMonth === $setup.planSummary.CappAccount.CONTRIB3?.MonthName }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.selectMonth($setup.planSummary.CappAccount.CONTRIB3?.MonthName)))
                  }, _toDisplayString($setup.formatDateToMonth($setup.planSummary.CappAccount.CONTRIB3?.MonthName)), 3),
                  _createElementVNode("h5", _hoisted_87, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.CONTRIB3.Value)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _hoisted_89,
                _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.TOTCONT)), 1)
              ]),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _hoisted_92,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.ADMINFEE)), 1)
                ]),
                _createElementVNode("div", _hoisted_93, [
                  ($setup.planSummary.CappAccount.REIMB !== 0)
                    ? (_openBlock(), _createElementBlock("h5", {
                        key: 0,
                        class: "link-text",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.openModal('hw-mrp-history', 'Medical Reimbursements History', 'plan-mrp', null, null, null, null, { From: $setup.planSummary.MrpFrom , To: $setup.planSummary.MrpTo })), ["prevent"]))
                      }, " Medical Reimbursements: "))
                    : (_openBlock(), _createElementBlock("h5", _hoisted_94, " Medical Reimbursements: ")),
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.REIMB)), 1)
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _hoisted_96,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.AMTAVAIL)), 1)
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _hoisted_98,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.COPAY)), 1)
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _hoisted_100,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.PREMPAY)), 1)
                ]),
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.XFERWAIV)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_103, [
                _hoisted_104,
                _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.BALANCE)), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_105, [
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _hoisted_108,
            _createElementVNode("table", null, [
              _hoisted_109,
              ($setup.filteredContributionDetails && $setup.filteredContributionDetails.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_110, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredContributionDetails, (contribution) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: contribution.ReportID
                      }, [
                        _createElementVNode("td", null, _toDisplayString(contribution.ReceiptDate), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.PeriodEnd), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.Employer) + " / " + _toDisplayString(contribution.Production), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.ReportID), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(contribution.Amount)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_111, _hoisted_113))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_114, [
          _createElementVNode("div", _hoisted_115, [
            _createElementVNode("h4", _hoisted_116, [
              _createTextVNode(" Statement Activity "),
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-tertiary",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.openModal('hw-capp-payments-history', 'CAPP Statements History', '', null, null, null)), ["prevent"]))
              }, "CAPP Statement/Co-Pay History")
            ]),
            _createElementVNode("table", null, [
              _hoisted_117,
              ($setup.planSummary.CappStatements && $setup.planSummary.CappStatements.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_118, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.planSummary.CappStatements, (statement) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: statement.ID
                      }, [
                        _createElementVNode("td", null, _toDisplayString(statement.CoverageBegins), 1),
                        _createElementVNode("td", null, _toDisplayString(statement.Type), 1),
                        _createElementVNode("td", null, _toDisplayString(statement.DateSent), 1),
                        _createElementVNode("td", null, _toDisplayString(statement.Status), 1),
                        _createElementVNode("td", null, _toDisplayString(statement.DueDate), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(statement.Balance)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_119, _hoisted_121))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_122, [
      _createElementVNode("div", _hoisted_123, [
        _createElementVNode("div", _hoisted_124, [
          _createElementVNode("p", null, [
            _createTextVNode("NOTE: Your CAPP Account represents “Contributions Available for Premium Payments” for the purpose of enrollment in one of the Plan C options (C-1, C-2, C-3, C-4 and MRP). Your contribution amounts have no cash value as it is a notional account. Refer to the "),
            _createElementVNode("a", {
              target: "_blank",
              href: `${$setup.baseUrl}/storage/app/media/documents/IATSE-National-HealthWelfare-Plan-C-SPD.pdf`
            }, "Plan C SPD", 8, _hoisted_125),
            _createTextVNode(" for eligibility, plan options and all other related information.")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_126, [
      _createElementVNode("div", _hoisted_127, [
        _hoisted_128,
        _createElementVNode("div", _hoisted_129, [
          _createVNode(_component_OtherCoverages, {
            otherCoverages: $setup.planSummary.OtherCoverages
          }, null, 8, ["otherCoverages"])
        ])
      ]),
      _createElementVNode("div", _hoisted_130, [
        _hoisted_131,
        _createElementVNode("div", _hoisted_132, [
          _createElementVNode("a", {
            href: "",
            class: "btn btn-secondary plan-modal",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => ($setup.openModal('add-beneficiary', 'My Beneficiary(ies)', 'plan-tables-striped beneficiary', null, null, null
                        )), ["prevent"]))
          }, " Beneficiary(ies) "),
          _createElementVNode("a", {
            href: "#",
            class: "btn btn-secondary btn-large plan-modal",
            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => ($setup.openModal('claims', 'Claims', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
          }, " Claims "),
          _createElementVNode("a", {
            href: "",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => ($setup.openModal('request-card', 'Request for Insurance ID Card(s)', 'plan-upload plan-card-info plan-profile-update')), ["prevent"])),
            class: "btn btn-secondary plan-modal"
          }, "Request ID Card(s)"),
          _createElementVNode("a", {
            href: "",
            class: "btn btn-secondary btn-large plan-modal",
            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => ($setup.openModal('dependents', 'My Dependents', null)), ["prevent"]))
          }, "My Dependents ")
        ])
      ])
    ])
  ]))
}